angular
  .module('bb.listing.open_houses')
  .factory('BBOpenHousesService', BBOpenHousesService);

BBOpenHousesService.$inject = ['$resource'];

function BBOpenHousesService($resource) {
  const Listing = $resource('/listing/open_houses');
  const OpenHouse = $resource('/listing/:listingId/open_house', {
    listingId: '@listingId',
  });

  function searchListing(type, location, address) {
    const SearchListing = $resource(`/listing/${type}/0${location}`);
    return SearchListing.get({
      address,
    }).$promise;
  }

  function getOpenHouses() {
    return Listing.get().$promise;
  }

  function createOpenHouse(listingId, type, timeFrom, timeTo) {
    const openHouse = {
      listingId,
      type,
      timeFrom,
      timeTo,
      isManualOpenHouse: true,
    };
    return OpenHouse.save(listingId, openHouse).$promise;
  }
  return {
    getOpenHouses,
    searchListing,
    createOpenHouse,
  };
}

export {};
